import React, { useEffect, useRef } from 'react';

const TouchHandler = ({ children, onSwipeLeft, onSwipeRight, onPullToRefresh }) => {
  const touchStartX = useRef(0);
  const touchStartY = useRef(0);
  const containerRef = useRef(null);
  const pullStartY = useRef(0);
  const pullMoveY = useRef(0);
  const isPulling = useRef(false);

  useEffect(() => {
    const container = containerRef.current;
    if (!container) return;

    const handleTouchStart = (e) => {
      touchStartX.current = e.touches[0].clientX;
      touchStartY.current = e.touches[0].clientY;
      pullStartY.current = e.touches[0].clientY;
      isPulling.current = true;
    };

    const handleTouchMove = (e) => {
      if (!isPulling.current) return;

      const touchX = e.touches[0].clientX;
      const touchY = e.touches[0].clientY;
      pullMoveY.current = touchY;

      const deltaX = touchX - touchStartX.current;
      const deltaY = touchY - touchStartY.current;

      // Handle pull to refresh
      if (container.scrollTop === 0 && deltaY > 0) {
        e.preventDefault();
        const pullDistance = pullMoveY.current - pullStartY.current;
        if (pullDistance > 0) {
          container.style.transform = `translateY(${pullDistance}px)`;
        }
      }

      // Handle swipe
      if (Math.abs(deltaX) > Math.abs(deltaY) && Math.abs(deltaX) > 50) {
        if (deltaX > 0 && onSwipeRight) {
          onSwipeRight();
        } else if (deltaX < 0 && onSwipeLeft) {
          onSwipeLeft();
        }
        isPulling.current = false;
      }
    };

    const handleTouchEnd = () => {
      if (isPulling.current) {
        const pullDistance = pullMoveY.current - pullStartY.current;
        if (pullDistance > 100 && onPullToRefresh) {
          onPullToRefresh();
        }
        container.style.transform = '';
      }
      isPulling.current = false;
    };

    container.addEventListener('touchstart', handleTouchStart, { passive: false });
    container.addEventListener('touchmove', handleTouchMove, { passive: false });
    container.addEventListener('touchend', handleTouchEnd);

    return () => {
      container.removeEventListener('touchstart', handleTouchStart);
      container.removeEventListener('touchmove', handleTouchMove);
      container.removeEventListener('touchend', handleTouchEnd);
    };
  }, [onSwipeLeft, onSwipeRight, onPullToRefresh]);

  return (
    <div ref={containerRef} className="touch-handler">
      {children}
    </div>
  );
};

export default TouchHandler; 